import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { registerCustomer } from '../api/rest-api';

const InititalForm = () => {

    const { register, handleSubmit, formState: { errors } } = useForm();
    const [phone, setPhone] = useState();
    const [customError, setCustomError] = useState();
    const location = useLocation();
    let navigate = useNavigate();

    const updateCustomer = async () => {

        let searchParams = new URLSearchParams(location.search);

        let locationId = searchParams.get("id");
        let data = {
            location: locationId ? locationId : '',
            phone: phone ? phone : ''
        }
        const updateResult = await registerCustomer(data);
        if (updateResult.isSuccess) {
            navigate('/offline/confirmation');
        } else {
            setCustomError('Customer details not added please try again!!!');
        }
    }

    const registerHandler = () => {
        updateCustomer();
    }

    // Handles Key Down Event.
    const handleKeydown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };

    const buttonStyles = {
        backgroundColor: '#14586F',
        '&:hover': {
            backgroundColor: '#FFBE08',
        },
        padding: '0.5rem 1.5rem',
        borderRadius: '0.5rem',
        color: 'white',
        '&:hover span': {
            color: 'black',
        },
    };

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', minHeight: '80vh', padding: '10px' }}>
                <div style={{ margin: 'auto', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <p> Hello There! </p>
                    <p style={{ marginBottom: '20px' }}> Thanks for showing interest in our products </p>

                    <h5 style={{ fontWeight: 'bold' }}> Please share your phone number to avail 20% off </h5>

                    <form id='register' onSubmit={handleSubmit(registerHandler)}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', margin: '10px 0px' }}>

                            <input
                                style={{ border: '1px solid #ccc', borderRadius: '4px', outline: 'none', width: '100%', padding: '0.375rem 0.75rem' }}
                                type="tel"
                                name="phone"
                                placeholder='Phone Number'
                                {...register('phone', { required: true, pattern: /^[0]?[789]\d{9}$/ })}
                                onChange={(event) => setPhone(event.target.value)}
                                onKeyDown={handleKeydown}
                            />
                            {errors.phone && (errors.phone.type === 'required' && <span style={{ color: '#e53e3e' }}> This field is required*. </span>)}
                            {errors.phone && (errors.phone.type === 'pattern' && <span style={{ color: '#e53e3e' }}> Invalid Pattern*. </span>)}
                            {customError && <span style={{ color: '#e53e3e' }}> {customError} </span>}

                            <p> We promise not to spam </p>
                        </div>

                    </form>
                    <div style={{ margin: '0.5rem 0' }}>
                        <button style={buttonStyles} type="submit" form="register">
                            Register
                        </button>
                    </div>
                </div>
            </div>

        </>
    );
}

export default InititalForm;